module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/bnr_300_250-8421dbd647365a3e8ab51203cb83176c.png";